import { isEmpty } from 'lodash';
import { useInfiniteQuery, useQuery } from 'react-query';
import { searchSettings } from '../../../config';
import { getTitleSuggestions, searchQueryByTitles } from './api';
import { titleKeys } from './keys';
import { assetQuery, AssetQueryOptions, titleQuery, TitleQueryOptions } from './queries';
import { SearchResults } from './types/search';

export function useSearchResultsQuery(query: string) {
  const queryText = query.trim();

  return useInfiniteQuery<SearchResults>(
    titleKeys.searchResults(queryText),
    ({ pageParam }) => searchQueryByTitles(queryText, pageParam),
    {
      enabled: !isEmpty(queryText),
      getNextPageParam: (lastPage) => {
        const limit = lastPage.totalCount;
        const newPage = lastPage.page + 1;

        if (newPage * searchSettings.resultsExpandLength >= limit) {
          return undefined;
        }

        return newPage;
      },
      staleTime: searchSettings.staleTime,
      keepPreviousData: true,
    },
  );
}

export function useTitleSuggestionsQuery<T = string[]>(query: string) {
  const queryText = query.trim();

  return useQuery<string[], T>(titleKeys.suggestString(queryText), () => getTitleSuggestions(queryText), {
    enabled: !isEmpty(queryText),
    staleTime: searchSettings.staleTime,
    useErrorBoundary: false,
  });
}

export function useTitle(options: TitleQueryOptions) {
  return useQuery(titleQuery(options));
}

export function useAsset(options: AssetQueryOptions) {
  return useQuery(assetQuery(options));
}
